export const WIDGET_COMPONENTS = {
  stars: 'wbtx-stars-widget',
  productReviews: 'wbtx-product-reviews-widget',
  carousel: 'wbtx-carousel-widget',
  fullPage: 'wbtx-full-page-widget',
  topRatedProducts: 'wbtx-top-rated-products-widget',
  reviewsTab: 'wbtx-reviews-tab-widget',
} as const;

export type WidgetComponentsKeys = keyof typeof WIDGET_COMPONENTS;
export type WidgetComponents = (typeof WIDGET_COMPONENTS)[WidgetComponentsKeys];

export const WIDGET_CONTAINERS = {
  stars: document.querySelectorAll(WIDGET_COMPONENTS.stars),
  productReviews: document.querySelectorAll(WIDGET_COMPONENTS.productReviews),
  carousel: document.querySelectorAll(WIDGET_COMPONENTS.carousel),
  fullPage: document.querySelectorAll(WIDGET_COMPONENTS.fullPage),
  topRatedProducts: document.querySelectorAll(
    WIDGET_COMPONENTS.topRatedProducts,
  ),
  reviewsTab: document.querySelectorAll(WIDGET_COMPONENTS.reviewsTab),
} as const;

export type WidgetContainers = typeof WIDGET_CONTAINERS;
